module.exports = __webpack_public_path__ + "img/blog-dp-photo-corners.e1c682e7.webp";